import store from "src/redux/store";

export const getSeriesInfo = () => {
  const slug = store.getState().global?.slug;
  const invitationCode = window.localStorage.getItem(slug);
  return { slug, invitationCode };
};
